<template>
  <div>
    <div v-if="show" class="blockClick" @click="show = false"></div>
    <nav class="navbar navbar-color is-fixed-bottom has-background-transparent">
      <div v-if="show" class="columns is-mobile is-marginless z-index33">
        <div class="column is-offset-5 is-7 has-background-white">
          <div @click.prevent="showModal('MailRecom')" class="mb-10">
            <p class="is-size-11px has-text-default">Demander des modifications</p>
          </div>
          <div @click="showModal('RefuRecom')">
            <p class="is-size-11px has-text-default">Refuser la proposition</p>
          </div>
        </div>
      </div>
      <div class="columns is-mobile is-marginless">
        <div class="column pa-10 is-5 has-background-white">
          <div class="level is-mobile">
            <div v-if="getNbrSelect" class="level-item is-marginless has-text-centered">
              <p>
                <label class="has-text-default is-size-10px">Total de la sélection</label> <br>
                <strong class="has-text-default is-size-14px has-text-right">{{solde}}</strong>
                <label class="has-text-default is-size-10px"> HT</label>
              </p>
            </div>
            <div v-else class="level-item">
              <p class="mt-10 mb-10">
                <label class="has-text-default is-size-10px">Aucun produit sélectionné</label>
              </p>
            </div>
          </div>
        </div>
        <div class="column pa-10 is-7 validiteM">
          <div class="level is-mobile">
            <div class="level-item is-marginless">
              <b-icon
                icon="check-circle"
                size=""
                class="mt-10 mb-10">
              </b-icon>
            </div>
            <div
              @click="showModal('ValidRecom'), validRecom = true"
              class="level-item is-size-7 is-marginless">
              <p class="is-size-11px has-text-weight-bold">
                Valider la proposition
              </p>
            </div>
            <div
              class="level-item"
              @click="show=!show, $parent.showContact = !show">
              <b-icon v-if="show"
                icon="chevron-up "
                size=""
                class="">
              </b-icon>
              <b-icon v-else
                icon="chevron-down"
                size=""
                class="">
              </b-icon>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <b-modal :active.sync="isModalActive"
      :full-screen="component === 'MailRecom'"
      has-modal-card
      :width="640" scroll="keep">
      <component
        :is="component"
        @close="isModalActive = false"
        @modif="component = 'MailRecom'"
        :valid="validRecom"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatNombre } from '@/services/general/general';
import RefuRecom from './actionsModal/RefuRecom';
import MailRecom from './actionsModal/MailRecom';
import ValidRecom from './actionsModal/ValidRecom';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    RefuRecom,
    MailRecom,
    ValidRecom,
  },
  data: () => ({
    isModalActive: false,
    component: '',
    validRecom: false,
    show: false,
    isModalActiveModif: false,
  }),
  computed: {
    ...Recommandation.mapGetters([
      'getSolde',
      'getNbrSelect',
    ]),
    solde() {
      return formatNombre(this.getSolde);
    },
  },
  methods: {
    showModal(type) {
      this.component = type;
      this.isModalActive = true;
    },
  },
};
</script>

<style>
</style>